export const enum FileTypeId {
  INE = 1,
  ConstanciaFiscal = 2,
  RPC = 3,
  CartaAutorizacion = 4,
  UltimoProtocolo = 5,
  PropuestaProspeccion = 6,
  NominaCiega = 7,
  Nomina = 8,
  ComprobanteDomicilio = 9,
  BoletaInscripcion = 10,
  Escrituras = 11,
  AnalisisJuridico = 12,
  AnalisisPropuesta = 13,
}

export interface DocumentTypeDef {
  id: FileTypeId;
  label: string;
  accept: string;
  hint: string;
  column: 1 | 2 | 3;
  enabled: boolean;
}

const IMG_PDF = '.pdf,.jpg,.jpeg,.png';
const IMG_PDF_XLS = '.pdf,.jpg,.jpeg,.png,.xls,.xlsx';

export const DOCUMENT_TYPES: DocumentTypeDef[] = [
  // Columna 1
  { id: FileTypeId.INE,                 label: 'INE',                     accept: IMG_PDF,     hint: 'PDF, JPG, PNG',            column: 1, enabled: true },
  { id: FileTypeId.ComprobanteDomicilio, label: 'Comprobante de Domicilio', accept: IMG_PDF,     hint: 'PDF, JPG, PNG',            column: 1, enabled: true },
  { id: FileTypeId.ConstanciaFiscal,    label: 'Constancia Fiscal',       accept: IMG_PDF,     hint: 'PDF, JPG, PNG',            column: 1, enabled: true },
  { id: FileTypeId.Escrituras,          label: 'Escrituras',              accept: IMG_PDF,     hint: 'PDF, JPG, PNG',            column: 1, enabled: true },
  { id: FileTypeId.RPC,                 label: 'RPC',                     accept: IMG_PDF,     hint: 'PDF, JPG, PNG',            column: 1, enabled: false },

  // Columna 2
  { id: FileTypeId.CartaAutorizacion,   label: 'Carta de Autorización',   accept: IMG_PDF,     hint: 'PDF, JPG, PNG',            column: 2, enabled: false },
  { id: FileTypeId.UltimoProtocolo,     label: 'Último Protocolo',        accept: IMG_PDF,     hint: 'PDF, JPG, PNG',            column: 2, enabled: true },
  { id: FileTypeId.PropuestaProspeccion, label: 'Ejercicios de Propuesta', accept: IMG_PDF_XLS, hint: 'PDF, JPG, PNG, XLS, XLSX', column: 2, enabled: true },
  { id: FileTypeId.NominaCiega,         label: 'Nómina Ciega',            accept: IMG_PDF_XLS, hint: 'PDF, JPG, PNG, XLS, XLSX', column: 2, enabled: true },
  { id: FileTypeId.Nomina,              label: 'Nómina',                  accept: IMG_PDF_XLS, hint: 'PDF, JPG, PNG, XLS, XLSX', column: 2, enabled: true },

  // Columna 3
  { id: FileTypeId.BoletaInscripcion,   label: 'Boleta de Inscripción',   accept: IMG_PDF,     hint: 'PDF, JPG, PNG',            column: 3, enabled: true },
  { id: FileTypeId.AnalisisJuridico,    label: 'Análisis Jurídico',       accept: IMG_PDF,     hint: 'PDF, JPG, PNG',            column: 3, enabled: true },
  { id: FileTypeId.AnalisisPropuesta,   label: 'Propuesta Comercial',     accept: IMG_PDF,     hint: 'PDF, JPG, PNG',            column: 3, enabled: true },
];
